import loadable from "@loadable/component";

import ModalForgot from "./ModalForgot";
import ModalInformation from "./ModalInformation";
import ModalMemberVipMobile from "./ModalMemberVipMobile";
import ModalMobileNotification from "./ModalMobileNotification";
import ModalNews from "./ModalNews";
import ModalVip from "./ModalVip";

const ModalSignin = loadable(() => import("./ModalSignin"));
const ModalSignUp = loadable(() => import("./ModalSignup"));
const ModalForgetPassword = loadable(() => import("./ModalForgetPassword"));

export const Modal = () => {
  return (
    <>
      <ModalSignin />
      <ModalSignUp />
      <ModalForgetPassword />
      <ModalNews />
      <ModalInformation />
      <ModalForgot />
      <ModalMobileNotification />
      <ModalVip />
      <ModalMemberVipMobile />
    </>
  );
};
